import { modalType, convertModalType } from '../../util/ModalUtil';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import CodeUtil from '../../util/CodeUtil';
import { CODE_GROUP_ID } from '../../constant/Constant';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import SelectionBox from '../../component/SelectionBox';
import InputBox from '../../component/InputBox';

import { actionAdd, actionEdit } from '../../module/body/system/SystemSubjectCodeModule';
import PopupRef from '../../component/PopupRef';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import NullCheckUtil from '../../util/NullCheckUtil';

const SystemSubjectCodeModal = ({ type, row, callback, modalRef }) => {
    // 변수 선언
    const [subjectId, setSubjectId] = useState(row && row.subjectId);
    const [subjectNm, setSubjectNm] = useState(row && row.subjectNm);
    const [subjectTypeCd, setSubjectTypeCd] = useState(row && row.subjectTypeCd);
    const [subjectDesc, setSubjectDesc] = useState(row && row.subjectDesc);

    const dispatch = useDispatch();
    const popupRef = useRef(null);

    useEffect(() => {
        if (type == modalType.ADD) {
            setSubjectTypeCd(CodeUtil.getCodes(CODE_GROUP_ID.SUBJECT_TYPE)[0].cd);
        }
    }, []);

    const handleCancel = () => {
        modalRef.current.close();
    };

    const handleConfirm = () => {
        if (NullCheckUtil.isEmpty(subjectNm)) {
            popupRef.current.openAlert('교과목을 입력하세요.');
        } else {
            if (type == modalType.ADD) {
                dispatch(
                    actionAdd({
                        data: {
                            subjectNm,
                            subjectTypeCd,
                            subjectDesc,
                        },
                        callback,
                    }),
                );
            } else if (type == modalType.EDIT) {
                dispatch(
                    actionEdit({
                        data: {
                            subjectId,
                            subjectNm,
                            subjectTypeCd,
                            subjectDesc,
                        },
                        callback,
                    }),
                );
            }
        }
    };

    // 타이틀 관련 수정 명확하도록 외부 변수로 처리 필요
    return (
        <>
            <ModalHeader title={type == modalType.ADD ? '과목코드 등록' : '과목코드 수정'} modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner SystemSubjectCodeModal'>
                    <InfoTxt infoTxt={type == modalType.ADD ? '과목코드를 등록합니다.' : '과목코드를 수정합니다.'} />
                    <div>
                        <div className='form-box-row'>
                            <SelectionBox
                                title='과정구분'
                                options={CodeUtil.getCodes(CODE_GROUP_ID.SUBJECT_TYPE)}
                                useAll={false}
                                value={subjectTypeCd}
                                onChange={(e) => setSubjectTypeCd(e.target.value)}
                            />
                        </div>
                        <div className='form-box-row'>
                            <InputBox title='교과목' value={subjectNm} onChange={(e) => setSubjectNm(e.target.value)} />
                        </div>
                        <div className='form-box-row'>
                            <InputBox title='비고' value={subjectDesc} onChange={(e) => setSubjectDesc(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default SystemSubjectCodeModal;
